import React, { useState } from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { colors } from '../styles';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';

export const Navbar = () => {
  const { user, userProfile, logout } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <Nav>
      <NavBrand to="/">Vision Board</NavBrand>
      
      <MenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
        {isMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
      </MenuButton>

      <NavLinks $isOpen={isMenuOpen}>
        <NavLink to="/explore">Explorar</NavLink>
        {user ? (
          <>
            <NavLink to={`/${userProfile?.username}/board`}>Mi Board</NavLink>
            <NavLink to="/profile">Perfil</NavLink>
            <LogoutButton onClick={handleLogout}>Cerrar Sesión</LogoutButton>
          </>
        ) : (
          <>
            <NavLink to="/login">Iniciar Sesión</NavLink>
            <NavLink to="/register">Registrarse</NavLink>
          </>
        )}
      </NavLinks>
    </Nav>
  );
};

const Nav = styled.nav`
  background: ${colors.white};
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px ${colors.shadow};
  position: relative;
  z-index: 1000;
`;

const NavBrand = styled(Link)`
  font-family: 'Homemade Apple', cursive;
  font-size: 1.5rem;
  color: ${colors.text};
  text-decoration: none;
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: ${colors.text};

  @media (max-width: 768px) {
    display: block;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    display: ${props => props.$isOpen ? 'flex' : 'none'};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: ${colors.white};
    padding: 1rem;
    box-shadow: 0 2px 4px ${colors.shadow};
    gap: 1rem;
  }
`;

const NavLink = styled(Link)`
  color: ${colors.text};
  text-decoration: none;
  font-family: 'Indie Flower', cursive;
  font-size: 1.1rem;
  transition: color 0.3s ease;

  &:hover {
    color: ${colors.secondary};
  }
`;

const LogoutButton = styled.button`
  background: none;
  border: none;
  color: ${colors.text};
  font-family: 'Indie Flower', cursive;
  font-size: 1.1rem;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: ${colors.secondary};
  }
`;
